const LOCATION = {

  id: "location",
  type: "dropdown",
  props: {
    isMulti: true,
    optionFilter: (item, formValues) => {
      const property_type_group = formValues.property_type_group?.value;
      if (property_type_group) {
        const re = new RegExp(item.category);
        console.log(re)
        return re.test(property_type_group);
      }
      return true;
    },
    dropdownProps: {
      label: "Location",
      buttonProps: {
        className: "location",
      },
      menuProps: {
        style: {
          // minWidth: 300
        }
      }
    },
    options: [
      { label: "D01 - Boat Quay / Raffles Place / Marina", value: "D01", category: "^(?!HDB$).+" },
      { label: "D02 - Chinatown / Tanjong Pagar", value: "D02", category: "^(?!HDB$).+" },
      { label: "D03 - Alexandra / Commonwealth", value: "D03", category: "^(?!HDB$).+" },
      { label: "D04 - Harbourfront / Telok Blangah", value: "D04", category: "^(?!HDB$).+" },
      { label: "D05 - Buona Vista / West Coast / Clementi", value: "D05", category: "^(?!HDB$).+" },
      { label: "D06 - City Hall / Clarke Quay", value: "D06", category: "^(?!HDB$).+" },
      { label: "D07 - Beach Road / Bugis / Rochor", value: "D07", category: "^(?!HDB$).+" },
      { label: "D08 - Farrer Park / Serangoon Rd", value: "D08", category: "^(?!HDB$).+" },
      { label: "D09 - Orchard / River Valley", value: "D09", category: "^(?!HDB$).+" },
      { label: "D10 - Tanglin / Holland / Bukit Timah", value: "D10", category: "^(?!HDB$).+" },
      { label: "D11 - Newton / Novena", value: "D11", category: "^(?!HDB$).+" },
      { label: "D12 - Balestier / Toa Payoh", value: "D12", category: "^(?!HDB$).+" },
      { label: "D13 - Macpherson / Potong Pasir", value: "D13", category: "^(?!HDB$).+" },
      { label: "D14 - Eunos / Geylang / Paya Lebar", value: "D14", category: "^(?!HDB$).+" },
      { label: "D15 - East Coast / Marine Parade", value: "D15", category: "^(?!HDB$).+" },
      { label: "D16 - Bedok / Upper East Coast", value: "D16", category: "^(?!HDB$).+" },
      { label: "D17 - Changi Airport / Changi Village", value: "D17", category: "^(?!HDB$).+" },
      { label: "D18 - Pasir Ris / Tampines", value: "D18", category: "^(?!HDB$).+" },
      { label: "D19 - Hougang / Punggol / Sengkang", value: "D19", category: "^(?!HDB$).+" },
      { label: "D20 - Ang Mo Kio / Bishan / Thomson", value: "D20", category: "^(?!HDB$).+" },
      { label: "D21 - Clementi Park / Upper Bukit Timah", value: "D21", category: "^(?!HDB$).+" },
      { label: "D22 - Boon Lay / Jurong / Tuas", value: "D22", category: "^(?!HDB$).+" },
      { label: "D23 - Dairy Farm / Bukit Panjang / Choa Chu Kang", value: "D23", category: "^(?!HDB$).+" },
      { label: "D24 - Lim Chu Kang / Tengah", value: "D24", category: "^(?!HDB$).+" },
      { label: "D25 - Admiralty / Woodlands", value: "D25", category: "^(?!HDB$).+" },
      { label: "D26 - Mandai / Upper Thomson", value: "D26", category: "^(?!HDB$).+" },
      { label: "D27 - Sembawang / Yishun", value: "D27", category: "^(?!HDB$).+" },
      { label: "D28 - Seletar / Yio Chu Kang", value: "D28", category: "^(?!HDB$).+" },

      { label: "Ang Mo Kio", value: "Ang Mo Kio", category: "HDB" },
      { label: "Bedok", value: "Bedok", category: "HDB" },
      { label: "Bishan", value: "Bishan", category: "HDB" },
      { label: "Bukit Batok", value: "Bukit Batok", category: "HDB" },
      { label: "Bukit Merah", value: "Bukit Merah", category: "HDB" },
      { label: "Bukit Panjang", value: "Bukit Panjang", category: "HDB" },
      { label: "Bukit Timah", value: "Bukit Timah", category: "HDB" },
      { label: "Central Area", value: "Central Area", category: "HDB" },
      { label: "Choa Chu Kang", value: "Choa Chu Kang", category: "HDB" },
      { label: "Clementi", value: "Clementi", category: "HDB" },
      { label: "Geylang", value: "Geylang", category: "HDB" },
      { label: "Hougang", value: "Hougang", category: "HDB" },
      { label: "Jurong East", value: "Jurong East", category: "HDB" },
      { label: "Jurong West", value: "Jurong West", category: "HDB" },
      { label: "Kallang/Whampoa", value: "Kallang/Whampoa", category: "HDB" },
      { label: "Lim Chu Kang", value: "Lim Chu Kang", category: "HDB" },
      { label: "Marine Parade", value: "Marine Parade", category: "HDB" },
      { label: "Pasir Ris", value: "Pasir Ris", category: "HDB" },
      { label: "Punggol", value: "Punggol", category: "HDB" },
      { label: "Queenstown", value: "Queenstown", category: "HDB" },
      { label: "Sembawang", value: "Sembawang", category: "HDB" },
      { label: "Sengkang", value: "Sengkang", category: "HDB" },
      { label: "Serangoon", value: "Serangoon", category: "HDB" },
      { label: "Tampines", value: "Tampines", category: "HDB" },
      { label: "Toa Payoh", value: "Toa Payoh", category: "HDB" },
      { label: "Woodlands", value: "Woodlands", category: "HDB" },
      { label: "Yishun", value: "Yishun", category: "HDB" }
    ]
  }

}

const COL_LOCATION = {

  id: "col_location",
  type: "col",
  props: {
    lg: 3,
    md: 4,
    xs: 6,
  },
  children: [LOCATION]

}

const COL_MODAL_LOCATION = {

  id: "col_location",
  type: "col",
  props: {
    lg: 6,
    md: 6,
    xs: 6,
  },
  children: [LOCATION]

}

export { LOCATION, COL_LOCATION, COL_MODAL_LOCATION };
